import React from 'react';
import useMemo from '@/util/hook/useMemo';
import { BUTTON_SIZE } from '@/config/ui/button';
import { BackButton, ForwardButton } from '../../component/atom/Button';
import Header from '../../component/atom/Header';
import Label from '../../component/atom/Label';
import CheckCard from '../../component/composite/Card/CheckCard';
import RWDPageLayout from '../../component/composite/RWDPageLayout';
import { S } from './style';
import { APP } from '../../config/app';
import { FORM_FIELD_ERROR_FEEDBACK_TEXT } from '../../config/error';
const renderHeader = () => (<Header progress={APP.PAGE_PROGRESS_INFO['/hospitalConfirmation'].progress} progressTitle={APP.PAGE_PROGRESS_INFO['/hospitalConfirmation'].title}/>);
const renderHospitalCard = ({ isHospitalInvalid, hospitalName, hospitalAddress, }) => (<>
    <Label title='您所在或鄰近的醫院'/>
    <CheckCard isChecked cardTitle={hospitalName} cardText={hospitalAddress}/>
    {isHospitalInvalid ? (<S.FeedbackError>{FORM_FIELD_ERROR_FEEDBACK_TEXT.DEFAULT}</S.FeedbackError>) : null}
  </>);
const renderFooter = ({ handleBackButtonClick, handleForwardButtonClick, }) => (<S.LayoutFooter>
    <BackButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleBackButtonClick}>
      修改
    </BackButton>
    <S.GapRow width={40}/>
    <ForwardButton size={BUTTON_SIZE.LARGE} isAvailable onButtonClick={handleForwardButtonClick}>
      下一步
    </ForwardButton>
  </S.LayoutFooter>);
export default function View({ 
// data
isLoading, hospitalAddress, hospitalName, isHospitalInvalid, 
// func
handleBackButtonClick, handleForwardButtonClick, }) {
    const header = useMemo(() => renderHeader(), []);
    const hospitalCard = useMemo(() => renderHospitalCard({ isHospitalInvalid, hospitalName, hospitalAddress }), [isHospitalInvalid, hospitalName, hospitalAddress]);
    const footer = useMemo(() => renderFooter({ handleBackButtonClick, handleForwardButtonClick }), [handleBackButtonClick, handleForwardButtonClick]);
    return (<RWDPageLayout isLoading={isLoading}>
      {header}
      <S.Layout>
        {hospitalCard}
        {footer}
      </S.Layout>
    </RWDPageLayout>);
}
